/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';

export const CustomerQuoteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CustomerQuoteContent = styled.div<{
  $background_color?: string
}>`
  background-color: ${({ $background_color, theme }) => $background_color ?? theme.surface[2]};
  border-radius: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 77px 0;
  position: relative;
  overflow: hidden;
`;

export const CustomerQuoteHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 750px;
  z-index: 2;
`;

export const CustomerQuoteLogo = styled.div<{ src: string }>`
  width: 100%;
  height: 55px;
  max-height: 55px;
  background-image: url(${props => props.src});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 32px;
`;

export const CustomerQuoteQuote = styled.h5`
  font-family: ${props => props.theme.font};
  color: ${props => props.theme.text.primary};
  padding: 0 16px;
  margin-bottom: 16px;
  text-align: center;
`;

export const CustomerQuoteAuthor = styled.p`
  font-family: ${props => props.theme.font};
  color: ${props => props.theme.text.primary};
  font-weight: 600;
  margin-bottom: 0;
  text-align: center;
`;

export const CustomerQuoteJobTitle = styled.p`
  font-family: ${props => props.theme.font};
  color: ${props => props.theme.text.secondary};
  margin-bottom: 32px;
  text-align: center;
`;

export const CustomerQuoteFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 750px;
  z-index: 2;
`;

export const CustomerQuoteLearnMoreLink = styled.a`
  color: ${props => props.theme.text.brand};
  display: flex;
  align-items: baseline;
  span {
    font-size: 140%;
    margin-left: 4px;
    font-weight: 400;
  }
`;

export const CustomerQuoteReadMoreLink = styled.div`
  display: flex;
  justify-content: center;
`;

export const CustomerQuoteReadMoreWrapper = styled.div`
  font-family: ${props => props.theme.font};
  margin-top: 32px;
  margin-bottom: 16px;
  color: ${props => props.theme.text.secondary};
`;

export const CustomerQuoteVector = styled.div`
  color: ${props => props.theme.fill.dimmedSecondary};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;

  div {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    svg {
      object-fit: none;
      position: absolute;
      right: calc(50% - 55%);
      top: -150px;
      z-index: 1;
      width: 110%;
      height: auto;
      transform: rotate(-0deg);

      @media (max-width: 980px) {
        width: 150%;
        top: -40%;
      }

      @media (min-width: 2000px) {
        width: 75%;
        right: calc(50% - 37.5%);
        top: -50%;
      }
      @media (min-width: 3000px) {
        width: 60%;
        right: calc(50% - 30%);
        top: -50%;
      }
    }
  }
`;
